import useRequest from '@/websdk/utils/request';
import { useEffect, useState } from 'react';

export default (function () {
  const [dataList, setDataList] = useState([]);
  const { data, exec } = useRequest({
    name: 'GET_DEVICES_EXTRA_LIST',
    url: `/api/machine/extra`,
  });

  useEffect(() => {
    if (data) {
      setDataList(data);
    }
  }, [data]);

  return [dataList || [], exec];
});
